import { Box, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import React from 'react'

const Notice = () => {
  console.log('I AM HERE!!!')

  return (
    <Box height={'100vh'} pt={15} pl={10} pr={5} bgcolor={'#F7F8FC'}>
      <Box
        display={'flex'}
        p={2}
        border={'1px solid #F4A3A3'}
        width={'fit-content'}
        borderRadius={2}
        bgcolor={'#FCF4F4'}
        gap={3}
      >
        <Box bgcolor={'#CA303A'} borderRadius={'100%'} p={0.5} width={'25px'} height={'25px'}>
          <ErrorOutlineIcon sx={{ fontSize: 25, color: '#FFF', margin: 0 }} />
        </Box>
        <div style={{ width: '100%' }}>
          <Typography variant="h5" color={'#CA303A'} textAlign={'left'}>
            Note to Agent
          </Typography>
          <Typography
            color="#252D36"
            variant="body2"
            textAlign={'left'}
            fontWeight={'400'}
            fontSize={'14px'}
            width={'100%'}
            mt={0.5}
          >
            {'The URL for Quility Level Term has changed. Please access the eApp at: '}
            <span>
              <a href="https://qlt-platform.afficiency.com/login"> https://qlt-platform.afficiency.com/login</a>
            </span>
          </Typography>
          <Typography
            variant="body2"
            color="#252D36"
            textAlign={'left'}
            fontWeight={'100'}
            fontSize={'14px'}
            width={'100%'}
          >
            {'Please update all bookmarks with this new URL.'}
          </Typography>
          <Typography
            color="#252D36"
            variant="body2"
            textAlign={'left'}
            fontWeight={'100'}
            fontSize={'14px'}
            width={'100%'}
            mt={2}
          >
            {
              'You must be registered to login and access the eApp. If you are not already registered you will receive an error message. You can register by selecting ‘Don’t have an account?’ on the Welcome page.'
            }
          </Typography>
        </div>
      </Box>
    </Box>
  )
}

export default Notice
